export default __webpack_public_path__ + "images/2_1_image.jpg";